<template>
  <div>
    <hshead title="我的行程" bgcolor="#fff" SquareBg="true"></hshead>
    <div class="trip-top">
        <div class="left-box">
            <div class="this-time">2019.06</div>
            <div class="this-h1">TODAY</div>
        </div>
        <div class="right-box">
            <img src="../assets/images/trip/add.png" alt="">
        </div>
    </div>
    <div class="trip-box">
        <div class="trip-tab-ul">
            <div class="tab-li"></div>
        </div>
    </div>
  </div>
</template>

<script>
import hshead from "@/components/common/hshead";
export default {
  name: "Trip",
  data() {
    return{

    }
  },
  components:{
      hshead
  }
};
</script>

<style lang="less" scoped>
</style>


// WEBPACK FOOTER //
// src/components/Trip.vue